import React from 'react'
import { useTranslation } from 'react-i18next'
import { createStyles, makeStyles } from '@mui/styles'

import logo from '../../../assets/img/logo.png'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    textColor: {
      color: theme.palette.primary.main
    }
  })
)

/**
 * HeaderLogo
 * @returns {div}
 */
export const HeaderLogo = () => {
  const { t } = useTranslation()
  const styleClasses = useStyles()
  const version = process.env.REACT_APP_VERSION

  return (
    <div className={`header_logo ${styleClasses.textColor}`}>
      <img src={logo} alt={t('autoplan.img_alt')} />
      <h1>{t('autoplan.title')}</h1>
      <div className={`version ${styleClasses.textColor}`}>{version ? `${version}` : 'no-version-found'}</div>
    </div>
  )
}
